import React, {createContext, useContext} from 'react'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

interface UIGameDetailsContextProps {
    matchmakingMatchType: MatchmakingMatchTypes | undefined
    isRanked: boolean
    isDiscord: boolean
}

const UIGameDetailsContext = createContext<UIGameDetailsContextProps | undefined>(undefined)

export const useUIGameDetailsContext = () => {
    const context = useContext(UIGameDetailsContext)
    if(!context) throw new Error('UIGameDetailsContext not found')
    return context
}

interface UIGameDetailsProviderProps {
    matchmakingMatchType: MatchmakingMatchTypes | undefined
    isRanked: boolean
    isDiscord: boolean
    children: React.ReactNode
}

export const UIGameDetailsProvider = ({
    matchmakingMatchType,
    isRanked,
    isDiscord,
    children,
}: UIGameDetailsProviderProps) => <UIGameDetailsContext.Provider value={{
    matchmakingMatchType: matchmakingMatchType,
    isRanked: isRanked,
    isDiscord: isDiscord,
}}>
    {children}
</UIGameDetailsContext.Provider>
